import { Avatar } from 'evergreen-ui';
import { styled } from 'linaria/react';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Group } from 'src/domain/group';
import { GroupGuard } from 'src/features/home/features/group/ui/group-guard';
import { GroupMenu } from 'src/features/home/features/group/ui/group-menu';
import { routes } from 'src/routes';
import surprise from 'src/assets/surprise.png';

const Description = styled.div`
	margin-bottom: 24px;
	font-size: 16px;
    line-height: 1.2;
`;
const Creator = styled.div`
	font-weight: 600;
	
	strong {
		color: var(--blue500);
		margin-left: 4px;
	}
`;
const GroupHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	height: 40px;
`;
const WardContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 16px;
	
	a {
		color: var(--blue500);
	}
`;

export const GroupMainPage: FC<{ group: Group | null }> = ({ group }) => {
	const isMember = Boolean(group?.joined_user);
	const creator = [
		group?.owner?.user.details.first_name,
		group?.owner?.user.details.last_name,
	].join(' ');
	const slaveName = group?.joined_user?.slave
		? [
			group?.joined_user?.slave.details.first_name,
			group?.joined_user?.slave.details.last_name,
		].join(' ')
		: null;

	return (
		<>
			<GroupHeader>
				<Creator>Creator: <strong>{creator}</strong></Creator>
				{isMember && <GroupMenu/>}
			</GroupHeader>
			<Description>
				{group?.description}
			</Description>
			{slaveName && (
				<WardContainer>
					<Avatar
						size={64}
						name={slaveName}
						src={group?.joined_user?.slave.details.avatar || undefined}
					/>
					<div style={{ marginTop: 10 }}>
						Your ward is <Link to={routes.root.home.group.slave.url(group?.id)}>{slaveName}</Link>
					</div>
				</WardContainer>
			)}
			{isMember ? (
				!slaveName && <div className="distribution">
						          <img src={surprise} alt=""/>
                                  <p>Distribution will happen soon</p>
					           </div>
			) : (
				<GroupGuard/>
			)}
		</>
	);
};
